import React from 'react';
import { ApLoaderDefault, ApLoaderText } from '@alixpartners/ui-components';
import { SecondaryNav } from '../SecondaryNav';
import { BudgetPerformance } from './BudgetPerformance';
import { TABLE_DIMENSIONS } from './utils';
import { getLocalStorageItem, setLocalStorageItem } from 'utils/localStorage';
import { LOCAL_STORAGE_KEY, PERIOD_KEY } from '../utils';
import { getBudgetFilters } from 'utils/apiRequests';
import { COLUMNS } from '../BudgetTable/utils';
import { getFormattedSpendWithSymbol } from 'utils/number';

import { LoadingWrapper, Wrapper } from './BudgetPerformance.styles';

export class BudgetPerformanceContainer extends React.Component {
	state = {
		filtersList: null,
		filterModel: this.getInitialFilterModel(),
		data: null,
		tableDimension: this.getDefaultTableDimension(),
		isFiltersLoading: false,
		isTableLoading: false,
	};

	componentDidMount() {
		this.fetchData();
	}

	getInitialFilterModel() {
		return getLocalStorageItem(LOCAL_STORAGE_KEY) || {};
	}

	getDefaultTableDimension() {
		const initialFilterModel = this.getInitialFilterModel();

		if (
			initialFilterModel.filters &&
			initialFilterModel.filters[COLUMNS.COST_CENTRE]
		) {
			return TABLE_DIMENSIONS[1].value;
		}

		return TABLE_DIMENSIONS[0].value;
	}

	componentDidUpdate(prevProps, prevState) {
		const { filterModel } = this.state;

		if (filterModel.primaryFilter !== prevState.filterModel.primaryFilter) {
			this.fetchData();
		}
	}

	fetchData = () => {
		this.fetchFiltersList().then(this.fetchTableData);
	};

	fetchTableData = () => {
		this.setState({ isTableLoading: true });

		return Promise.resolve([]).then(data => {
			this.setState({ data, isTableLoading: false });
		});
	};

	fetchFiltersList = () => {
		const { filterModel } = this.state;
		this.setState({ isFiltersLoading: true });

		return getBudgetFilters({
			primaryFilter: filterModel.primaryFilter,
		})
			.then(filtersList => {
				const periodDimension = filtersList.find(
					({ dimension }) => dimension === PERIOD_KEY
				);

				this.setState({
					filtersList: [
						...(periodDimension ? [periodDimension] : []),
						...filtersList.filter(({ dimension }) => dimension !== PERIOD_KEY),
					],
					isFiltersLoading: false,
				});
			})
			.catch(() => {
				this.setState({ isFiltersLoading: false });
			});
	};

	tableDimensionChange = ({ target: { value } }) => {
		this.setState({ tableDimension: Number(value) });
	};

	changeFilterModel = (filterModel, cb) => {
		setLocalStorageItem(LOCAL_STORAGE_KEY, filterModel);
		this.setState({ filterModel }, cb);
	};

	spendFormatter = (value, withZero) => {
		const { currencySymbol } = this.props;

		return value || withZero
			? getFormattedSpendWithSymbol(value, currencySymbol).toUpperCase()
			: '-';
	};

	render() {
		const {
			data,
			filtersList,
			filterModel,
			tableDimension,
			isFiltersLoading,
		} = this.state;

		return (
			<Wrapper>
				<SecondaryNav />
				{!data || !filtersList ? (
					<LoadingWrapper>
						<ApLoaderDefault loaderText={() => <ApLoaderText />} />
					</LoadingWrapper>
				) : (
					<BudgetPerformance
						onTableDimensionChange={this.tableDimensionChange}
						tableDimension={tableDimension}
						filtersList={filtersList}
						filterModel={filterModel}
						onFilterModelChange={this.changeFilterModel}
						isFiltersLoading={isFiltersLoading}
						spendFormatter={this.spendFormatter}
					/>
				)}
			</Wrapper>
		);
	}
}
